'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _components = {
	_$UserProvider: {
		displayName: 'UserProvider'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var _require = require('react');

var Component = _require.Component;
var PropTypes = _require.PropTypes;
var Children = _require.Children;

var didWarnAboutReceivingUser = false;
function warnAboutReceivingUser() {
	if (didWarnAboutReceivingUser) {
		return;
	}

	didWarnAboutReceivingUser = true;
	console.error( // eslint-disable-line no-console
	'<UserProvider> does not support changing `user` on the fly. ');
}

var UserProvider = (function (_Component) {
	_inherits(UserProvider, _Component);

	UserProvider.prototype.getChildContext = function getChildContext() {
		return {
			user: this.user
		};
	};

	function UserProvider(props, context) {
		_classCallCheck(this, _UserProvider);

		_Component.call(this, props, context);
		this.user = props.user;
	}

	UserProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var user = this.user;
		var nextUser = nextProps.user;

		if (user !== nextUser) {
			warnAboutReceivingUser();
		}
	};

	UserProvider.prototype.render = function render() {
		var children = this.props.children;

		return Children.only(children);
	};

	var _UserProvider = UserProvider;
	UserProvider = _wrapComponent('_$UserProvider')(UserProvider) || UserProvider;
	return UserProvider;
})(Component);

UserProvider.propTypes = {
	user: PropTypes.object.isRequired,
	children: PropTypes.element.isRequired
};
UserProvider.childContextTypes = {
	user: PropTypes.object.isRequired
};

module.exports = UserProvider;


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-acl/src/UserProvider.js
 ** module id = 1005
 ** module chunks = 1
 **/